/* eslint-disable */
// import React, { useEffect, useState } from 'react';
// import Select from 'react-select';
// import jwt_decode from "jwt-decode";
// import axios from 'axios';
// import { Form, Button, Row, Col, Table, Pagination, ProgressBar } from 'react-bootstrap';
// import * as XLSX from 'xlsx';
// import Papa from 'papaparse';
// import { usePopupManager } from '../../../providers/PopupManager/PopupManager';
// import { MESSAGE_TYPE } from '../../../constants';
// import config from '../../../config/config';
// // import GridLoadingSpinner from '../GridLoadingSpinner/GridLoadingSpinner';
// import styles from './TemplateUploadComp.module.css';

// const MAX_RECORDS = 10000;
// const PAGE_SIZE = 100;

// const { API_BASE_URL } = config;

// const TemploadUpload = () => {
//   // eslint-disable-next-line no-unused-expressions, no-undef
//   const UserToken = keycloak.token;
//   let username = '';
//   let Email = '';

//   if(UserToken !== undefined || UserToken !== null){
//     const decoded = jwt_decode(UserToken);
//     username = decoded.preferred_username
//     Email = decoded.email
//   } else{
//     console.log("test null..!")
//   }

//   const { showPopup } = usePopupManager();

//   const [fileName, setFileName] = useState('');
//   const [file, setFile] = useState(null);
//   const [fullData, setFullData] = useState([]);
//   const [tableData, setTableData] = useState([]);
//   const [headers, setHeaders] = useState([]);
//   const [entityOptions, setEntityOptions] = useState([]);
//   const [entity, setEntity] = useState('undefined');
//   const [currentPage, setCurrentPage] = useState(1);
//   const [uploadProgress, setUploadProgress] = useState(0);
//   const [isUploading, setIsUploading] = useState(false);

//   const [moduleOptions, setModuleOptions] = useState([
//     { value: 'TemplateUpload', label: 'New Template Upload' },
//     { value: 'ExistiongTemplate', label: 'Update Existing Template' }
//   ]);
//   const [selectedModule, setSelectedModule] = useState(null);

//   const handleModuleChange = (val) => {
//     setSelectedModule(val);

//     const fetchEntityOptions = async () => {
//       try {
//         const response = await axios.post(`${API_BASE_URL}/api/file-upload-entity-options`, 
//           {user_name: username},
//           {
//             headers: {
//               Authorization: `Bearer ${localStorage.getItem('ApiToken')}`
//             }
//           }
//         );
//         const options = response.data.entityOptions;
//         setEntityOptions(options);
//       } catch (error) {
//         console.error("Failed to fetch entity options:", error);
//       }
//     };

//     fetchEntityOptions();
//   };

//   useEffect(() => {
//     const fetchEntityOptions = async () => {
//       try {
//         const response = await axios.post(`${API_BASE_URL}/api/file-upload-entity-options`, 
//           {user_name: username},
//           {
//             headers: {
//               Authorization: `Bearer ${localStorage.getItem('ApiToken')}`
//             }
//           }
//         );
//         const options = response.data.entityOptions;
//         setEntityOptions(options);
//       } catch (error) {
//         console.error("Failed to fetch entity options:", error);
//       }
//     };

//     fetchEntityOptions();
//   }, []);

//   const handleFileChange = (e) => {
//     const selectedFile = e.target.files[0];
//     const allowedExtensions = ['csv', 'xls', 'xlsx'];
//     const fileExtension = selectedFile?.name.split('.').pop();
//     if (selectedFile && allowedExtensions.includes(fileExtension)) {
//       setFile(selectedFile);
//       setFileName(selectedFile.name);
//     } else {
//       alert('Please upload a valid Excel or CSV file.');
//       e.target.value = null;
//       setFile(null);
//       setFileName('');
//     }
//   };

//   const handleView = () => {
//     if (!file) {
//       showPopup({
//         type: MESSAGE_TYPE.INFORMATION,
//         contextText: MESSAGE_TYPE.INFORMATION,
//         info: "No file selected.",
//       });
//       return;
//     }
//     // if (entity === 'undefined') {
//     if (!entity || entity === 'undefined') {
//       showPopup({
//         type: MESSAGE_TYPE.INFORMATION,
//         contextText: MESSAGE_TYPE.INFORMATION,
//         info: "Select entity.",
//       });
//       return;
//     } 
//     const reader = new FileReader();
//     const ext = file.name.split('.').pop();
//     const processData = (data) => {
//       const limited = data.slice(0, MAX_RECORDS);
//       setFullData(limited);
//       setHeaders(Object.keys(limited[0] || {}));
//       setCurrentPage(1);
//       setTableData(limited.slice(0, PAGE_SIZE));
//     };
//     if (ext === 'csv') {
//       reader.onload = (e) => {
//         const text = e.target.result;
//         Papa.parse(text, {
//           header: true,
//           complete: (result) => processData(result.data),
//         });
//       };
//       reader.readAsText(file);
//     } else {
//       reader.onload = (e) => {
//         const data = new Uint8Array(e.target.result);
//         const workbook = XLSX.read(data, { type: 'array' });
//         const sheetName = workbook.SheetNames[0];
//         const sheet = workbook.Sheets[sheetName];
//         const jsonData = XLSX.utils.sheet_to_json(sheet, { defval: '' });
//         processData(jsonData);
//       };
//       reader.readAsArrayBuffer(file);
//     }
//   };

//   const handleEntity = (val) => {
//     setEntity(val);
//   }

//   const handleSubmit = async (e) => {
//     if (!file) {
//       showPopup({
//         type: MESSAGE_TYPE.INFORMATION,
//         contextText: MESSAGE_TYPE.INFORMATION,
//         info: "No file selected.",
//       });
//       return;
//     }
//     if (entity === 'undefined') {
//       showPopup({
//         type: MESSAGE_TYPE.INFORMATION,
//         contextText: MESSAGE_TYPE.INFORMATION,
//         info: "Select entity.",
//       });
//       return;
//     }
//     const formData = new FormData();
//     formData.append('user_id', username);
//     // formData.append('entity_name', entity.label);
//     formData.append('entity_name', typeof entity === 'string' ? entity : entity.label);
//     formData.append('file_name', file.name);
//     formData.append('status', 'Pending');
//     // formData.append('approved_name', entity.value);
//     formData.append('approved_name', typeof entity === 'string' ? entity : entity.value);
//     formData.append('uploaded_file', file);

//     try {
//       const token = localStorage.getItem('ApiToken');
//       setIsUploading(true);
//       setUploadProgress(0);
//       const response = await axios.post(
//         `${API_BASE_URL}/api/file-upload-maker`,
//         formData,
//         {
//           headers: {
//             'Content-Type': 'multipart/form-data',
//             Authorization: `Bearer ${token}`,
//           },
//           onUploadProgress: (progressEvent) => {
//             const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//             setUploadProgress(percentCompleted);
//           }
//         }
//       );

//       showPopup({
//         type: MESSAGE_TYPE.SUCCESS,
//         contextText: MESSAGE_TYPE.SUCCESS,
//         info: "File uploaded successfully",
//       });
//     } catch (error) {
//       console.error('Upload error:', error.response?.data || error.message);
//       showPopup({
//         type: MESSAGE_TYPE.FAILURE,
//         contextText: MESSAGE_TYPE.FAILURE,
//         info: "File uploaded failed",
//       });
//     } finally {
//       setIsUploading(false);
//     }
//   };

//   const handlePageChange = (pageNumber) => {
//     const start = (pageNumber - 1) * PAGE_SIZE;
//     const end = start + PAGE_SIZE;
//     setCurrentPage(pageNumber);
//     setTableData(fullData.slice(start, end));
//   };

//   const renderPagination = () => {
//     const totalPages = Math.ceil(fullData.length / PAGE_SIZE);
//     let items = [];
//     items.push(
//       <Pagination.Prev
//         key="prev"
//         disabled={currentPage === 1}
//         onClick={() => handlePageChange(currentPage - 1)}
//       />
//     );

//     for (let i = 1; i <= totalPages; i++) {
//       if (
//         i === 1 || i === totalPages || 
//         (i >= currentPage - 2 && i <= currentPage + 2)
//       ) {
//         items.push(
//           <Pagination.Item
//             key={i}
//             active={i === currentPage}
//             onClick={() => handlePageChange(i)}
//           >
//             {i}
//           </Pagination.Item>
//         );
//       } else if (
//         (i === currentPage - 3 && i !== 2) ||
//         (i === currentPage + 3 && i !== totalPages - 1)
//       ) {
//         items.push(<Pagination.Ellipsis key={`ellipsis-${i}`} disabled />);
//       }
//     }
//     items.push(
//       <Pagination.Next
//         key="next"
//         disabled={currentPage === totalPages}
//         onClick={() => handlePageChange(currentPage + 1)}
//       />
//     );
//     return <Pagination>{items}</Pagination>;
//   };

//   return (
//     <div className={`${styles.filter_panel_container}`}>
//       <Row className="align-items-end">
//         <Col md={3}>
//           <label className="fw-bold">Module</label>
//           <Select
//             placeholder="Select module"
//             value={selectedModule}
//             onChange={handleModuleChange}
//             options={moduleOptions}
//             isSearchable={false}
//             menuPortalTarget={document.body}
//             styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
//           />
//         </Col>
//         {/* <Col md={3}>
//           <label className="fw-bold">Entity</label>
//           <Select
//             placeholder="select entity"
//             value={entity}
//             onChange={handleEntity}
//             options={entityOptions}
//             isSearchable={false}
//             menuPortalTarget={document.body}
//             styles={{
//               menuPortal: (base) => ({ ...base, zIndex: 9999 }),
//             }}
//           />
//         </Col> */}
//         <Col md={3}>
//             <label className="fw-bold">Entity</label>
//             {selectedModule?.value === 'TemplateUpload' ? (
//                 <Form.Control
//                 type="text"
//                 placeholder="Enter entity name"
//                 value={entity}
//                 onChange={(e) => setEntity(e.target.value)}
//                 />
//             ) : (
//                 <Select
//                 placeholder="Select entity"
//                 value={entity}
//                 onChange={handleEntity}
//                 options={entityOptions}
//                 isSearchable={false}
//                 menuPortalTarget={document.body}
//                 styles={{
//                     menuPortal: (base) => ({ ...base, zIndex: 9999 }),
//                 }}
//                 />
//             )}
//         </Col>

//         <Col md={4}>
//           <label className="fw-bold">Select a file</label>
//           <div className="d-flex">
//             <Form.Control
//               type="text"
//               value={fileName}
//               placeholder="No file selected"
//               readOnly
//               className="me-2"
//             />
//             <Button variant="secondary" onClick={() => document.getElementById('hiddenFileInput').click()}>
//               Browse
//             </Button>
//             <Form.Control
//               type="file"
//               id="hiddenFileInput"
//               style={{ display: 'none' }}
//               accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
//               onChange={handleFileChange}
//             />
//           </div>
//         </Col>

//         <Col md={2} className="d-flex gap-2 mt-3 mt-md-0">
//           <Button variant="outline-secondary" onClick={handleView}>View</Button>
//           <Button variant="primary" onClick={handleSubmit}>Submit</Button>
//         </Col>
//         {isUploading && (
//           <div
//             style={{
//               position: 'fixed',
//               top: 0,
//               left: 0,
//               width: '100vw',
//               height: '100vh',
//               backgroundColor: 'rgba(255, 255, 255, 0.8)',
//               zIndex: 9999,
//               display: 'flex',
//               flexDirection: 'column',
//               justifyContent: 'center',
//               alignItems: 'center',
//             }}
//           >
//             <div className="text-center">
//               <div className="spinner-border text-primary mb-3" role="status"></div>
//               <p className="mb-3" style={{ fontSize: "18px", fontWeight: "bold", color: "#0983b1" }}>Uploading File...</p>
//               <ProgressBar
//                 now={uploadProgress}
//                 label={`${uploadProgress}%`}
//                 animated
//                 striped
//                 style={{ width: '300px' }}
//               />
//             </div>
//           </div>
//         )}
//       </Row>
//       {tableData.length > 0 && (
//         <div className="mt-4">
//           <div className="py-3">
//             <h5>
//               Uploaded File Data (showing {tableData.length} of {fullData.length} records)
//             </h5>
//           </div>
//           <div className="table-responsive" style={{ maxHeight: '400px', overflowY: 'auto' }}>
//             <Table hover size="sm" className="mb-0">
//               <thead className="table-light custom-thead" style={{ position: 'sticky', top: 0, zIndex: 1 }}>
//                 <tr>
//                   {headers.map((header, idx) => (
//                     <th key={idx}>{header}</th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody className="custom-tbody">
//                 {tableData.map((row, i) => (
//                   <tr key={i}>
//                     {headers.map((header, j) => (
//                       <td key={j}>{row[header]}</td>
//                     ))}
//                   </tr>
//                 ))}
//               </tbody>
//             </Table>
//           </div>
//           <div className="d-flex justify-content-end mt-3">
//             {renderPagination()}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default TemploadUpload;

// ######################## Updated ############################
/* eslint-disable */
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import jwt_decode from "jwt-decode";
import { Form, Button, Row, Col, Spinner, ProgressBar } from 'react-bootstrap';
import Select from 'react-select';
import config from '../../../config/config';
import { usePopupManager } from '../../../providers/PopupManager/PopupManager';
import { MESSAGE_TYPE } from '../../../constants';
// import './TemploadUpload.css';
import styles from './TemplateUploadComp.module.css';

const { API_BASE_URL } = config;

const TemploadUpload = () => {
  const { showPopup } = usePopupManager();
    // eslint-disable-next-line no-unused-expressions, no-undef
    const UserToken = keycloak.token;
    let username = '';
    let Email = '';

    if(UserToken !== undefined || UserToken !== null){
        const decoded = jwt_decode(UserToken);
        username = decoded.preferred_username
        Email = decoded.email
    } else{
        console.log("test null..!")
    }

  const [file, setFile] = useState(null);
  const [module, setModule] = useState(null);
  const [selectedModule, setSelectedModule] = useState(null);
  const [entity, setEntity] = useState('');
  const [entityOptions, setEntityOptions] = useState([]);
  const [maker, setMaker] = useState('');
  const [checker, setChecker] = useState('');
  const [makerOptions, setMakerOptions] = useState([]);
  const [checkerOptions, setCheckerOptions] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const moduleOptions = [
    { label: 'New Template Upload', value: 'TemplateUpload' },
    { label: 'Update Existing Template', value: 'UpdateTemplate' }
  ];

  useEffect(() => {
    setSelectedModule(moduleOptions[0]);
  }, []);

  const fetchEntityOptions = async () => {
    try {
      const response = await axios.post(`${API_BASE_URL}/api/file-upload-entity-options`, 
        {
          user_name: username
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('ApiToken')}`
          }
        }
      );
      const options = response.data.entityOptions;
      setEntityOptions(options);
    } catch (error) {
      console.error("Failed to fetch entity options:", error);
    }
  };

  const fetchOtherOptions = async (selectedEntityName) => {
    try {
    const response = await axios.post(`${API_BASE_URL}/api/file-upload-other-options`, 
      {
        entity_name: selectedEntityName
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('ApiToken')}`
        }
      }
    );
    const makerOptions = response.data.userOptions;
    const approverOptions = response.data.approverOptions;
    setMakerOptions(makerOptions);
    setCheckerOptions(approverOptions);
    } catch (error) {
    console.error("Failed to fetch entity options:", error);
    }
  };

  const handleModuleChange = (selected) => {
    setSelectedModule(selected);
    fetchEntityOptions();
    setEntity('');
    setMaker('');
    setChecker('');

    if (selected.value === 'UpdateTemplate') {
      fetchEntityOptions();
    }
  };

  const handleEntityChange = (val) => {
    setEntity(val);
    if (val !== 'undefined') {
      fetchOtherOptions(val.label);
    }
  };

  const handleMakerChange = (val) => {
    setMaker(val);
    // console.log("test data ---------------->", val.label);
  };

  const handleCheckerChange = (val) => {
    setChecker(val);
    // console.log("test data ---------------->", val.label);
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    
    if (selectedFile) {
      setFile(selectedFile);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!file || !selectedModule) {
      showPopup({
        type: MESSAGE_TYPE.FAILURE,
        contextText: MESSAGE_TYPE.FAILURE,
        info: "Please select required fields",
      });
      return;
    }

    // console.log("submit click --------->", entity, maker, checker);
    
    const formData = new FormData();
    formData.append('template_file', file);
    formData.append('module', selectedModule.value);
    formData.append('entity', typeof entity === 'string' ? entity : entity?.label);
    formData.append('maker', typeof maker === 'string' ? maker : maker?.label);
    formData.append('checker', typeof checker === 'string' ? checker : checker?.label);
    formData.append('status', 'Pending');

    try {
      setUploading(true);
      setUploadProgress(0);

      const response = await axios.post(`${API_BASE_URL}/api/file-template-upload`, formData, {
        headers: { 
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${localStorage.getItem('ApiToken')}`
        },
        onUploadProgress: (progressEvent) => {
          const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setUploadProgress(progress);
        },
      });

    //   showMessage('File uploaded successfully!', MESSAGE_TYPE.SUCCESS);
      showPopup({
        type: MESSAGE_TYPE.SUCCESS,
        contextText: MESSAGE_TYPE.SUCCESS,
        info: "File uploaded successfully!",
      });
      setFile(null);
      setUploadProgress(0);
    } catch (error) {
      console.error('Upload error:', error);
      showPopup({
        type: MESSAGE_TYPE.FAILURE,
        contextText: MESSAGE_TYPE.FAILURE,
        info: "Upload failed. Please try again.",
        });
    //   showMessage('Upload failed. Please try again.', MESSAGE_TYPE.ERROR);
    } finally {
      setUploading(false);
    }
  };

  return (
    // <div className="tempload-upload-container">
    <div className={`${styles.filter_panel_container}`}>
      <Form onSubmit={handleSubmit}>
        <Row className="mb-4">
          <Col md={3}>
            <label className="fw-bold">Module</label>
            <Select
              value={selectedModule}
              onChange={handleModuleChange}
              options={moduleOptions}
              isSearchable={false}
            />
          </Col>

          <Col md={3}>
            <label className="fw-bold">Entity</label>
            {selectedModule?.value === 'TemplateUpload' ? (
              <Form.Control
                type="text"
                placeholder="Enter entity"
                value={entity}
                onChange={(e) => setEntity(e.target.value)}
                // onChange={handleEntityChange}
              />
            ) : (
              <Select
                placeholder="Select entity"
                value={entity}
                // onChange={(val) => setEntity(val)}
                onChange={handleEntityChange}
                options={entityOptions}
                isSearchable={false}
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              />
            )}
          </Col>

          <Col md={3}>
            <label className="fw-bold">File Creater</label>
            {selectedModule?.value === 'TemplateUpload' ? (
              <Form.Control
                type="text"
                placeholder="Enter File Creater"
                value={maker}
                onChange={(e) => setMaker(e.target.value)}
              />
            ) : (
              <Select
                placeholder="Select File Creater"
                value={maker}
                // onChange={(val) => setMaker(val)}
                onChange={handleMakerChange}
                options={makerOptions}
                isSearchable={false}
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              />
            )}
          </Col>

          <Col md={3}>
            <label className="fw-bold">File Approver</label>
            {selectedModule?.value === 'TemplateUpload' ? (
              <Form.Control
                type="text"
                placeholder="Enter File Approver"
                value={checker}
                onChange={(e) => setChecker(e.target.value)}
              />
            ) : (
              <Select
                placeholder="Select File Approver"
                value={checker}
                // onChange={(val) => setChecker(val)}
                onChange={handleCheckerChange}
                options={checkerOptions}
                isSearchable={false}
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              />
            )}
          </Col>
        </Row>

        <Row className="mb-4">
          <Col md={6}>
            <label className="fw-bold">Upload File</label>
            <Form.Control type="file" onChange={handleFileChange} />
          </Col>
        </Row>

        {uploading && (
          <Row className="mb-3">
            <Col md={6}>
              <ProgressBar now={uploadProgress} label={`${uploadProgress}%`} />
            </Col>
          </Row>
        )}

        <Button
          type="submit"
          variant="primary"
          disabled={uploading}
        >
          {uploading ? (
            <>
              <Spinner animation="border" size="sm" /> Uploading...
            </>
          ) : (
            'Upload File'
          )}
        </Button>
      </Form>
    </div>
  );
};

export default TemploadUpload;


// ####################### New code ############################
// import React, { useEffect, useState } from 'react';
// import Select from 'react-select';
// import axios from 'axios';
// import { Form, Row, Col, Button } from 'react-bootstrap';
// import { usePopupManager } from '../../../providers/PopupManager/PopupManager';
// import { MESSAGE_TYPE } from '../../../constants';
// import config from '../../../config/config';

// const { API_BASE_URL } = config;

// const FileUploadForm = ({ username }) => {
//   const { showPopup } = usePopupManager();
//   const [selectedModule, setSelectedModule] = useState(null);
//   const [entity, setEntity] = useState('');
//   const [entityOptions, setEntityOptions] = useState([]);
//   const [attributeName, setAttributeName] = useState('');
//   const [attributeType, setAttributeType] = useState('');
//   const [attributeNameOptions, setAttributeNameOptions] = useState([]);
//   const [attributeTypeOptions, setAttributeTypeOptions] = useState([]);

//   useEffect(() => {
//     fetchEntities();
//   }, []);

//   const fetchEntities = async () => {
//     try {
//       const response = await axios.post(
//         `${API_BASE_URL}/api/fetch-entity-upload`,
//         { user_name: username },
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem('ApiToken')}`,
//           },
//         }
//       );
//       setEntityOptions(response.data);
//     } catch (error) {
//       console.error('Entity fetch failed:', error);
//     }
//   };

//   const fetchAttributeOptions = async () => {
//     try {
//       const response = await axios.post(
//         `${API_BASE_URL}/api/attribute-options`,
//         { user_name: username },
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem('ApiToken')}`,
//           },
//         }
//       );
//       setAttributeNameOptions(response.data.attributeNames);
//       setAttributeTypeOptions(response.data.attributeTypes);
//     } catch (error) {
//       console.error('Attribute fetch failed:', error);
//     }
//   };

//   const handleModuleChange = (val) => {
//     setSelectedModule(val);
//     setEntity('');
//     setAttributeName('');
//     setAttributeType('');

//     if (val.value === 'ExistiongTemplate') {
//       fetchAttributeOptions();
//     }
//   };

//   const handleEntity = (val) => setEntity(val);

//   const handleSubmit = async () => {
//     if (!entity || !attributeName || !attributeType) {
//       showPopup({
//         type: MESSAGE_TYPE.INFORMATION,
//         contextText: MESSAGE_TYPE.INFORMATION,
//         info: 'Please provide entity, attribute name, and attribute type.',
//       });
//       return;
//     }

//     const formData = new FormData();
//     formData.append('module', selectedModule?.value);
//     formData.append('entity', typeof entity === 'string' ? entity : entity.label);
//     formData.append(
//       'attribute_name',
//       typeof attributeName === 'string' ? attributeName : attributeName.label
//     );
//     formData.append(
//       'attribute_type',
//       typeof attributeType === 'string' ? attributeType : attributeType.label
//     );

//     // Submit logic here...
//     console.log('Submitting:', Object.fromEntries(formData));
//   };

//   return (
//     <Form>
//       <Row className="align-items-end">
//         <Col md={3}>
//           <label className="fw-bold">Module</label>
//           <Select
//             placeholder="Select module"
//             value={selectedModule}
//             onChange={handleModuleChange}
//             options={[
//               { value: 'TemplateUpload', label: 'New Template Upload' },
//               { value: 'ExistiongTemplate', label: 'Update Existing Template' },
//             ]}
//             isSearchable={false}
//           />
//         </Col>

//         <Col md={3}>
//           <label className="fw-bold">Entity</label>
//           {selectedModule?.value === 'TemplateUpload' ? (
//             <Form.Control
//               type="text"
//               placeholder="Enter entity name"
//               value={entity}
//               onChange={(e) => setEntity(e.target.value)}
//             />
//           ) : (
//             <Select
//               placeholder="Select entity"
//               value={entity}
//               onChange={handleEntity}
//               options={entityOptions}
//               isSearchable={false}
//               menuPortalTarget={document.body}
//               styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
//             />
//           )}
//         </Col>

//         {selectedModule?.value === 'TemplateUpload' ? (
//           <>
//             <Col md={3}>
//               <label className="fw-bold">Attribute Name</label>
//               <Form.Control
//                 type="text"
//                 placeholder="Enter attribute name"
//                 value={attributeName}
//                 onChange={(e) => setAttributeName(e.target.value)}
//               />
//             </Col>
//             <Col md={3}>
//               <label className="fw-bold">Attribute Type</label>
//               <Form.Control
//                 type="text"
//                 placeholder="Enter attribute type"
//                 value={attributeType}
//                 onChange={(e) => setAttributeType(e.target.value)}
//               />
//             </Col>
//           </>
//         ) : (
//           <>
//             <Col md={3}>
//               <label className="fw-bold">Attribute Name</label>
//               <Select
//                 placeholder="Select attribute name"
//                 value={attributeName}
//                 onChange={(val) => setAttributeName(val)}
//                 options={attributeNameOptions}
//                 isSearchable={false}
//                 menuPortalTarget={document.body}
//                 styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
//               />
//             </Col>
//             <Col md={3}>
//               <label className="fw-bold">Attribute Type</label>
//               <Select
//                 placeholder="Select attribute type"
//                 value={attributeType}
//                 onChange={(val) => setAttributeType(val)}
//                 options={attributeTypeOptions}
//                 isSearchable={false}
//                 menuPortalTarget={document.body}
//                 styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
//               />
//             </Col>
//           </>
//         )}

//         <Col md={12} className="mt-3">
//           <Button variant="primary" onClick={handleSubmit}>
//             Submit
//           </Button>
//         </Col>
//       </Row>
//     </Form>
//   );
// };

// export default FileUploadForm;
